import { useGameStore } from '@/store/gameStore';
export function HowToPlayScreen() {
  const setScreen = useGameStore((s) => s.setScreen);
  const startGame = useGameStore((s) => s.startGame);
  return (
    <div className="flex flex-col items-center justify-center w-full h-full bg-slate-950 select-none">
      <div className="flex flex-col items-center gap-6 px-8 text-center max-w-sm">
        <h2 className="text-3xl font-black text-cyan-400 drop-shadow-[0_0_20px_rgba(0,212,255,0.6)]">
          HOW TO PLAY
        </h2>
        <div className="w-full h-px bg-gradient-to-r from-transparent via-cyan-500 to-transparent" />
        <div className="flex flex-col gap-4 text-left w-full">
          <div className="flex items-start gap-3">
            <span className="text-2xl">🚗</span>
            <p className="text-slate-300 text-sm leading-relaxed">
              You're a car blazing down a 3-lane highway. Dodge oncoming traffic to survive.
            </p>
          </div>
          <div className="flex items-start gap-3">
            <span className="text-2xl">⌨️</span>
            <p className="text-slate-300 text-sm leading-relaxed">
              Use <span className="text-cyan-400 font-bold">← →</span> arrow keys to switch lanes on desktop.
            </p>
          </div>
          <div className="flex items-start gap-3">
            <span className="text-2xl">👆</span>
            <p className="text-slate-300 text-sm leading-relaxed">
              Swipe left or right on mobile to change lanes.
            </p>
          </div>
          <div className="flex items-start gap-3">
            <span className="text-2xl">⚡</span>
            <p className="text-slate-300 text-sm leading-relaxed">
              Traffic speeds up over time. How long can you survive?
            </p>
          </div>
        </div>
        <div className="w-full h-px bg-gradient-to-r from-transparent via-slate-600 to-transparent" />
        <div className="flex flex-col gap-3 w-full max-w-[240px]">
          <button
            onClick={startGame}
            className="px-10 py-4 bg-cyan-500 hover:bg-cyan-400 active:scale-95 text-slate-950 font-black text-lg rounded-xl transition-all duration-150 shadow-[0_0_30px_rgba(0,212,255,0.4)]"
          >
            START GAME
          </button>
          <button
            onClick={() => setScreen('lobby')}
            className="px-8 py-3 bg-slate-800 hover:bg-slate-700 active:scale-95 text-slate-300 font-bold text-sm rounded-xl transition-all duration-150"
          >
            Back to Menu
          </button>
        </div>
      </div>
    </div>
  );
}